var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "is-reacted";
},"3":function(container,depth0,helpers,partials,data) {
    return "\n     <span class='comment-reaction-tooltip-user'>"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "</span><br>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda;

  return "<div class=\"btn btn-primary btn-sm comment-reaction-item "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.userReacted : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " toggle-reaction\"\n     data-toggle=\"tooltip\" data-html=\"true\"\n     title=\""
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.reactionUsers : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "     <span class='comment-reaction-tooltip-reacted'>"
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias1,"communication:reaction.user-reacted",{"name":"i18n","hash":{},"data":data}))
    + "</span>\">\n    <i class=\"fa "
    + alias2(alias3((depth0 != null ? depth0.faClass : depth0), depth0))
    + "\" style=\"font-size: 15px;\"></i>\n    <span class=\"comment-reaction-users-num\">"
    + alias2(alias3((depth0 != null ? depth0.reactionUsersNum : depth0), depth0))
    + "</span>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./communication/ui/comment/template/reaction-item.hbs
// module id = 912
// module chunks = 0